import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import { FaucetIcon, FlaskIcon, LightningIcon, ShieldIcon, SippLogo } from '../../../icons'
import { useNavigate } from 'react-router'

const Info = [
  {
    icon: <ShieldIcon />,
    title: 'Understand the risks',
    desc: 'Find out what’s actually in your water and how it affects your health.',
  },
  {
    icon: <FaucetIcon />,
    title: 'Go beyond public data',
    desc: 'We test for 16 key contaminants right at your tap.',
  },
  {
    icon: <LightningIcon color="primary"/>,
    title: 'Instant results',
    desc: 'See clear, accurate insights in seconds right from your phone.',
  },
]

export const SIPPDescription = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <Stack
      sx={{
        p: 2,
        bgcolor: '#F3F6F8',
        borderRadius: '8px',
        borderTop: `4px solid ${theme.palette.info.main}`,
      }}
  >
      <Stack direction={'row'} gap={0.5} alignItems={'center'}>
        <SippLogo sx={{ fontSize: '3rem' }} />
        <Typography fontSize="1rem" color={'#075380'} fontWeight={theme.typography.fontWeightBold}>
          What’s in your water?
        </Typography>
      </Stack>

      <Stack>
        <Typography
          fontSize={'1rem'}
          color={'primary.dark'}
          fontWeight={theme.typography.fontWeightBold}
        >
          Test water quality in your home
        </Typography>
        <Typography
          fontSize={'0.875rem'}
          color={theme.palette.grey[600]}
          fontWeight={theme.typography.fontWeightMedium}
        >
          Get instant insights about your water safety using advanced AI technology
        </Typography>
      </Stack>

      <Stack gap={2.5} mt={4}>
        {Info.map((item, index) => (
          <Stack gap={0.5} key={index}>
            <Box>{item.icon}</Box>
            <Typography
              fontSize={'1rem'}
              color={'primary.dark'}
              fontWeight={theme.typography.fontWeightBold}
            >
              {item.title}
            </Typography>
            <Typography
              fontSize={'0.875rem'}
              color={theme.palette.grey[600]}
              fontWeight={theme.typography.fontWeightMedium}
            >
              {item.desc}
            </Typography>
          </Stack>
        ))}

        <Button
          variant="contained"
          disableElevation
          sx={{
            textTransform: 'capitalize',
            py: 1,
            px: 1.5,
            background: theme.palette.info.main,
            borderRadius: '8px',
            fontSize: '0.875rem',
          }}
          onClick={() => navigate('/landing')}
        >
          Analyze your water
        </Button>
      </Stack>
    </Stack>
  )
}
